//
//
//
//

import AV from "leancloud-storage";

export default {
  name: "GetOppenId",
  async created() {
    let from = this.$route.query.from;
    let code = this.$route.query.code;

    // 如果 query 中存在 code 参数，
    // 则表示是微信授权后跳转过来的
    if (code) {
      let state = this.$route.query.state;
      try {
        let openId = await AV.Cloud.run("getWechatOpenIdByCode", { code });
        var url = new URL(state);
        if (url) {
          url.searchParams.set("openId", openId);
        }
        window.location.href = url.href;
      } catch (err) {
        window.location.href = state;
      }
    } else if (from) {
      let authUrl = "http://m.xczim.com/get-open-id";
      window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx722a2cb8530f222f&redirect_uri=${authUrl}&response_type=code&scope=snsapi_base&state=${from}#wechat_redirect`;
    }
  },
  props: {},
  data() {
    return {};
  },
  methods: {
  },
  computed: {},
  components: {},
};



// WEBPACK FOOTER //
// ./src/pages/account/GetOpenId.vue